import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Button, IconButton } from "@mui/material";
import { useFormikContext } from "formik";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import { tableConfig } from "../../../../../../../../../../commons/table/tableConfig";
import { StyledResolucion } from '../../../../../../../../../../styled/Prevencion';

const ProtRadTable = ({
  data,
  handleOpenForm,
  handleDelete,
}) => {
  const { values } = useFormikContext();
  const disabled = !values.equipoRadiologico;

  const columns = useMemo(() => [
    {
      accessorKey: "cuitResponsable",
      header: "CUIL",
      size: 150,
    },
    {
      accessorKey: "tituloProfesional",
      header: "Título Profesional",
      size: 200,
    },
    {
      accessorKey: "matriculaProfesional",
      header: "Matrícula",
      size: 150,
    },
    {
      accessorKey: "numeroHabilitacion",
      header: "Nro. Habilitación",
      size: 180,
    },
  ], []);

  const table = useMaterialReactTable({
    columns,
    data: data || [],
    enableRowActions: true,
    positionActionsColumn: "last",
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "Operaciones",
      },
    },
    renderRowActions: ({ row }) => (
      <div style={{ display: 'flex', gap: '8px' }}>
        <IconButton
          disabled={disabled}
          onClick={() => handleOpenForm({ ...row.original, index: row.index })}
          size="small"
          color="primary"
        >
          <EditIcon />
        </IconButton>
        <IconButton
          disabled={disabled}
          onClick={() => handleDelete(row.index)}
          size="small"
          color="error"
        >
          <DeleteIcon />
        </IconButton>
      </div>
    ),
    renderTopToolbarCustomActions: () => (
      <StyledResolucion.HeaderContainer>
        <StyledResolucion.TableTitle>
          Encargado de Protección Radiológica
        </StyledResolucion.TableTitle>
      </StyledResolucion.HeaderContainer>
    ),
    renderBottomToolbarCustomActions: () => (
      <StyledResolucion.TableFooterButtonContainer>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => handleOpenForm(null)}
        >
          Agregar
        </Button>
      </StyledResolucion.TableFooterButtonContainer>
    ),
    muiPaginationProps: {
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === 'first') return 'ir a la primera página';
        if (type === 'last') return 'ir a la última página';
        if (type === 'next') return 'ir a la página siguiente';
        return 'ir a la página anterior';
      },
      labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count}`,
    },
    localization: {
      ...MRT_Localization_ES,
      noRecordsToDisplay: "No hay datos que mostrar",
    },
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
      density: 'compact',
    },
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enableFilters: false,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enablePagination: true,
    paginationDisplayMode: 'pages',
    muiTableHeadCellProps: {
      sx: { ...tableConfig.muiTableHeadCellProps?.sx }
    },
    muiTableBodyRowProps: {
      sx: { ...tableConfig.muiTableBodyRowProps?.sx }
    },
  });

  return (
    <StyledResolucion.TableContainer>
      <MaterialReactTable table={table} />
    </StyledResolucion.TableContainer>
  );
};

export default ProtRadTable;